( function($) {

	var app = {

		initLoadButton: function(){
			$('.ip-blog-load-btn a').on('click', function(){
				$(this).hide();
				$('.ip-blog-content-container').addClass('active');
			});
		},
	}

	
	$(document).ready( function() {
		app.initLoadButton();
	});
	
	$(window).on('load', function(){

	});

})(jQuery);